import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionRounded = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 22",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 11,
		cy: 11,
		r: 11,
		fill: "#FFEE58"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.1869 12.132H11.6509L11.7949 11.34C13.1749 11.004 14.2309 10.344 14.2309 8.772V8.748C14.2309 7.116 12.9589 6.132 11.1349 6.132C9.71893 6.132 8.68693 6.684 7.93093 7.452L9.16693 9.012C9.75493 8.484 10.3909 8.184 10.9909 8.184C11.6149 8.184 11.9749 8.46 11.9749 8.904V8.928C11.9749 9.492 11.4469 9.852 9.97093 9.96L9.87493 10.056L10.1869 12.132ZM9.69493 15H12.0709V12.9H9.69493V15Z",
		fill: "black"
	})]
});
export default SvgQuestionRounded;
